import useResource from 'app/hooks/useResource';

import {
  getJobConfigTemplates,
  setJobConfigTemplateParams
} from 'app/actions/jobConfigTemplates';

import {
  createJobConfigTemplate,
  updateJobConfigTemplate,
  destroyJobConfigTemplates
} from 'app/services/jobConfigTemplates';

import {
  jobConfigTemplates as resource
} from 'app/resources';

const useJobConfigTemplates = () => {
  return useResource({
    resource,
    getResource: getJobConfigTemplates,
    createResource: createJobConfigTemplate,
    updateResource: updateJobConfigTemplate,
    destroyResource: destroyJobConfigTemplates,
    setResourceParams: setJobConfigTemplateParams
  });
}

export default useJobConfigTemplates;
